namespace('compass.show');
compass.require('compass.arctic.ShowInfoWidget');

compass.show.LoginWidget = compass.defineWidget(function LoginWidget (options) {
	var me = this;
	var $j = jQuery;
	var d = $j.dom.getContext(me);

	var ENTER_KEY = 13;

	var _settings = options;
	var _inputs = {};
	var _submitEnabled = true;
	var _formatNumber = compass.util.phoneFormatter({}) || {};

	var __form;
	var _idLevelLogin = _settings.branchInfo.attendance_id || _settings.branchInfo.group_id; // if group or attendance we won't be drawing login.

	var _idStruct = {
		loginOptionInstruction: compass.generateId()
	};
	var passwordFailLabel = "Your email or password didn't match, let's try that again.";
	var _handleForgottenPW = function(e) {
		me.trigger('LoginWidget.ForgotPasswordRequest', {onpeakID:_settings.onpeakID});
		e.preventDefault();
		return false;
	};

	var _handleLogin = function() {

		var params = {
				password : _inputs.password.val(),
				failedLoginFunction : me.showFailedLoginMessage,
				multipleMatchesFunction : me.showLoginChoices,
				showLoginNotAllowedFunction : me.showLoginNotAllowedMessage
		};

		me.find('input[type=hidden]').map(function(i,e){
			params[$j(e).attr('name')] = $j(e).val();
		});
		if(_inputs.login) {
			params["login"] = _inputs.login.val();
		}

		var button = me.find('.login.button');
		button.find('.buttonLabel').hide();
		button.addClass('disabled');
		_submitEnabled = false;
		compass.loading.start(button, { color : '#FFFFFF' });
		me.trigger('LoginWidget.LoginAttempt', params);
	};

	var _render = this.render = function (widgetElem) {
		widgetElem.append(
			d.div({className:'loginError', role: 'alert', 'ARIA-role': 'alert'}),
			d.div({ className : 'loginWrapper'},
					d.form({ className : 'loginForm'},
						d.div({ className : 'loginInputs' },
							_idLevelLogin ? _drawIdLevelHiddens() : _drawLoginInput(),
							_drawPasswordInput(),
							_drawSecurityMsg()
						),
						d.input({
							name: "route",
							type: "hidden",
							'ARIA-hidden': true,
							value: _settings.branchInfo.route
						}),
						d.div({ className : 'clear' }),
						d.div({ className : 'loginControls'},
								_drawLoginButton(),
								d.div({ className : 'clear' })
						)
				),
				_drawForgotPW()
			),
			d.div({className : 'systemMessageWrapper', role : 'alert', 'ARIA-role': 'alert'}),
			d.div({ className : 'clear' })
		);


		__form = me.find('form.loginForm');
		__form.parsley({
			aria: true,
			errorClass: 'invalid',
			errorsContainer: function (elem) {
				elem = elem.$element;
				var $container = elem.next();

				if ($container.hasClass('reqHint')) {
					return $container;
				}

				var $container = d.div({ className: 'reqHint' });
				$container.append(d.div({ className: 'triangle' }));

				elem.after($container);

				elem.one('focus', function (evt) {
					$container.css({ "left": (elem.outerWidth(true)-$container.outerWidth(true))/2 + elem.position().left });
				});

				return $container;
			},
			errorsWrapper: '<div class=\'text\'></div>',
			errorTemplate: '<span></span>'
		});

		__form.on('submit', function (evt) {
			if ( _submitEnabled === false ) return false;
			evt.preventDefault();
			evt.stopPropagation();
			_handleLogin();
		});


		__form.parsley().on('form:error', function(e) {
			return;
 		});

		me.find("#email-input").emailautocomplete({
			suggClass: "eac-sugg",
			domains: ["aol.com", "att.net", "bellsouth.net", "comcast.com", "comcast.net", "gmail.com", "hotmail.com", "icloud.com", "live.com", "me.com", "msn.com", "outlook.com", "qq.com", "sbcglobal.net", "yahoo.com", "ymail.com"]
		});
	};

	var _drawIdLevelHiddens = function(){
		return [
			_settings.branchInfo.attendance_id ?  d.input({type : 'hidden', 'ARIA-hidden': true, name : 'attendance_id', value : _settings.branchInfo.attendance_id}):null,
			_settings.branchInfo.group_id ? d.input({type : 'hidden', 'ARIA-hidden': true, name : 'group_id',value : _settings.branchInfo.group_id}) : null];
	};

	var _drawLoginInput = function () {
		_inputs.login = d.input({
			className: "login email-autocomplete",
			name: "login",
			type: "email",
			autcomplete: 'off',
			id: "email-input",
			'aria-label' : 'Email Address',
			'data-parsley-required': 'true',
			'data-parsley-error-message': 'A valid email address is required',
			'data-parsley-type': 'email'
		}).val(_settings.prepopEmail);

		var field = d.fieldLabelPair({
			className : 'emailField',
			label : 'Email Address'
		}, [_inputs.login]);

		return field;
	};

	var _drawPasswordInput = function () {
		_inputs.password = d.input({
			className: "password",
			name: "password",
			type: "password",
			'aria-label' : 'Password',
			'data-parsley-required': 'true',
			'data-parsley-error-message': 'Please enter your password.'
		});

		var field = d.fieldLabelPair({
			className : 'passwordField',
			label : 'Password'
		}, [_inputs.password]);


		return field;

	};

	var _drawSecurityMsg = function() {
		var secMsg = 'Note: Periodically changing your password provides greater security.';
		return d.div({className: 'securityMsg secondaryText', role : 'contentinfo', 'aria-role' : 'contentinfo'}, secMsg);
	};

	var _drawForgotPW = function () {
		return d.div({ className: "forgotPassword secondaryText" },
			d.span("Forgot password?"),
			d.a({href:'#'}, "Reset &raquo;").activate(_handleForgottenPW)
		);
	};

	var _drawLoginButton = function () {
		return d.button({
			className: "login button",
			role : 'button',
			'aria-role' : 'button',
			tabindex : 0
		}, d.span({className: 'buttonLabel'}, "Log In"));
	};

	var _drawMeetingInfo = function() {

		var showInfoContainer = d.div({className:"loginOptionShowInfoWrapper"});
		
		var headerWrapper = d.div({className:"loginOptionsHeaderWrapper"},
			showInfoContainer,
			d.h2({
				className:"loginOptionInstruction",
				tabindex: 0
			}, "It looks like you have more than one record with us. Which one would you like to access?")
		);
		
		// Create ShowInfoWidget instance - it will auto-render into the container
		new compass.arctic.ShowInfoWidget(showInfoContainer, {
			meetingInfo: _settings.meetingInfo
		});
		
		return headerWrapper;
	};

	var _drawLoginError = function() {
		var loginErrorMessage = d.div(
					d.div({className: 'systemMessageCopy'}, "Still having trouble?"),
					d.a({className: 'systemMessageCopy', href: '#'}, "Reset your password now").activate(_handleForgottenPW)
				);
		if (_settings.meetingInfo.phone) {
			loginErrorMessage.append(d.div({className: 'systemMessageCopy'}, "If you continue to have problems please contact us " + _formatNumber(_settings.meetingInfo.phone)));
		}
		return loginErrorMessage;
	};

	this.registerReenableOnChange = function() {
		var _reenableOnChange = function(evt) {
			if ( evt.type === 'keydown' && ( evt.keyCode == 13 || evt.keyCode == 10 || evt.keyCode == 9 )){
				return;
			}
			me.find('.login.button').removeClass('disabled');
			_submitEnabled = true;
			me.find('.login, .password').off('change',_reenableOnChange);
			me.find('.login, .password').off('keydown',_reenableOnChange);
		};

		me.find('.login, .password').on('change',_reenableOnChange);
		me.find('.login, .password').on('keydown',_reenableOnChange);
	};

	this.showFailedLoginMessage = function() {
		compass.loading.stop();
		var button = me.find('.login.button');
		button.find('.buttonLabel').show();

		me.registerReenableOnChange();

		me.find('.loginError').html(d.div({className:'error'},'We were unable to log you in with the email and password provided. Please try again.')).show();
		me.find('.systemMessageWrapper').html(_drawLoginError()).show();
		me.find('input.login').focus();
	};

	this.showLoginChoices = function(matchedLoginArray) {
		var content = d.div({className: "matchedResultsWrapper"},_drawMeetingInfo());
		var callbacks = {
			failedLoginFunction : me.showFailedLoginMessage,
			multipleMatchesFunction : me.showLoginChoices,
			showLoginNotAllowedFunction : me.showLoginNotAllowedMessage,
			closeLoginChoices : ()=>{_LoginDialog.close();}
		};

		for (i=0;i<=matchedLoginArray.length - 1;i++) {
			(function(match) {

			var ids = [];
			for (j=0;j<3;j++) {
				ids.push(compass.generateId());
			}
			var idsString = _.foldl(ids, function(idsString, id){return idsString + id + ' ';}, '');

			content.append(
				d.div({className:"lookupOptionWrapper" + (i>4 ? " hide" : "")},
					d.div({className:"lookupOption name", id: ids[0] }, match.DISPLAYNAME + " | " + match.CATEGORY_NAME),
					d.div({className:"lookupOption onPeakId", id: ids[1]},_settings.meetingInfo.officeName+" " + match.TYPE + " ID: " + match.ID),
					d.div({className:"lookupOption createdInfo", id: ids[2]},"Created " + match.DATEENTERED + " at " + match.TIMEENTERED),
					d.button({
						className:"loginOptionButton secondaryButton",
						role : 'button',
						'aria-role' : 'button',
						'aria-describedby' : idsString,
						tabindex : 0
					},
						"View This Record").activate(function(){
							me.trigger("LoginOptionClicked.buttonClick", {"loginObj":match, "loginWidget": me, "callbacks": callbacks});
					})
				)
			);
			}(matchedLoginArray[i]));
		}

		if(matchedLoginArray.length > 5) {
			var showRemainingResults = function() {
				$j(".lookupOptionWrapper.hide").show();
				$j(".showMoreLink").hide();
			};

			content.append(
				d.div({className : "showMoreLinkWrapper"},
					d.a({
						className : "showMoreLink"
						}, "Show more &raquo;").activate(showRemainingResults)
				)
			);
		}

		_LoginDialog = d.dialog({
			classes: "lookupOptionsDialog",
			showParent: true,
			disableClicksOutsideModal: true,
			contents: content
		});

		compass.trackPageView('MultiRecordSelector');
	};

	this.showLoginNotAllowedMessage = function(reason) {
		compass.loading.stop();
		var button = me.find('.login.button');
		button.find('.buttonLabel').show();

		me.registerReenableOnChange();

		let message = 'Login for this record is not allowed.'; // default message, should never show but just in case
		if (reason === 'PAYMENT_REQUIRED_GROUP_MEMBER') {
			message = 'This reservation is part of a group that requires payment. Please contact your group manager for assistance.';
		}
		me.find('.loginError').html(d.div({className:'error'}, message)).show();

		me.find('input.login').focus();
	};

	this.grabValues = function() {
		return { password : _inputs.password.val() };
	};

}, {
	WUID: 'defaultLoginWidgetWUID',
	widgetName: 'LoginWidget',
	prepopEmail : '',
	branchInfo : {},
	meetingInfo : {},
	onpeakID : null
});
